import {
  Accordion,
  AccordionSummary,
  alpha,
  Box,
  Button,
  Divider,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography,
  styled,
} from '@mui/material';

import { textFieldDefaultStyle } from '../../../../../../components/UI/Typography';

export const CriteriasContainerGrid = styled(Grid)(() => ({
  marginTop: '40px',
  border: '1px solid #D7D8DB',
  borderRadius: '8px',
  padding: '40px',
  maxHeight: '780px',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  overflow: 'hidden',
  '& > .MuiGrid-item': {
    flexBasis: 'auto',
  },
}));

export const NoContentText = styled(Typography)(() => ({
  fontSize: '14px',
  color: '#8B8C8E',
  opacity: 0.8,
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  width: '100%',
  backgroundColor: 'transparent',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.6)}`,
  borderRadius: '10px',
  marginBottom: '8px',
  overflow: 'hidden',
  '&:first-of-type': {
    borderRadius: '10px',
  },
  '&:last-of-type': {
    borderRadius: '10px',
  },
  '&.Mui-expanded': {
    margin: 0,
    marginBottom: '8px',
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  margin: '0',
  padding: '8px 16px',

  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
  },

  // Remove todas as transições do summary
  transition: 'none !important',

  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
    transition: 'none',
  },

  // Remove margens quando expandido
  '&.Mui-expanded': {
    minHeight: '70px',
    margin: '0 !important',

    '& .MuiAccordionSummary-content': {
      margin: '0 !important',
    },
  },

  // Estilo para o ícone de expandir
  '& .expandIcon': {
    color: theme.palette.primary.main,
    marginLeft: '12px',
    transition: 'transform 0.3s ease',
    display: 'inline-flex',

    '.Mui-expanded &': {
      transform: 'rotate(180deg)',
    },
  },
}));

export const AccordionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 15,
  fontWeight: 700,
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
}));

export const ContentContainer = styled(Box)(() => ({
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '6px',
}));

export const ScrollableGrid = styled(Grid)(({ theme }) => ({
  width: '100%',
  paddingRight: '8px',
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  borderRadius: '6px',
  '& > .MuiGrid-item': {
    width: '100%',
    display: 'block',
  },

  '&::-webkit-scrollbar': {
    width: 10,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.primary.dark,
    borderRadius: 10,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '32px 0',
  },
}));

export const InfoBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  paddingLeft: 8,
  maxWidth: 600,
}));

export const DisplacementText = styled(Box)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.common.grey,
  fontWeight: 500,
  display: 'flex',
  gap: 2,
}));

export const DisplacementValue = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 600,
  marginLeft: '4px',
}));

export const ItemTitle = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 700,
  marginTop: '12px',
}));

export const CriteriaContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '16px',
  paddingLeft: '12px',
}));

export const CriterionLabel = styled(Typography)(() => ({
  fontWeight: 600,
  marginBottom: '4px',
}));

export const StyledDottedDivider = styled(Divider)(() => ({
  borderStyle: 'dotted',
  borderBottomWidth: '1px',
  borderBottomColor: '#D7D8DB',
  marginBottom: '24px',
}));

export const SubsectionTitle = styled(Typography)(() => ({
  fontWeight: 500,
  marginBottom: 24,
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  width: '210px',
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: theme.palette.secondary.main,
  fontFamily: 'Montserrat',
  fontWeight: '600',
  height: '48px',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  width: '210px',
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  fontWeight: '600',
  height: '48px',
  color: '#FAFCFF',
  backgroundColor: theme.palette.secondary.main,
  fontFamily: 'Montserrat',
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
}));

export const TitleMoldal = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '18px',
  display: 'flex',
  gap: 4,
  span: {
    color: theme.palette.primary.main,
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  width: '100%',
  textAlign: 'start',
  '&.MuiOutlinedInput-root': {
    borderRadius: 16,
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.grey,
    },
  },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.common.grey,
  '&.Mui-focused': {
    color: theme.palette.common.grey,
  },
}));
